const state = {
    quote: false,
    vehicle: false,
    showModal: false,
    paymentSearch: false,
};

const getters = {
};

const actions = {
};

const mutations = {
    setQuote(state, quote) {
        state.quote = quote;
    },
    setVehicle(state, vehicle) {
        state.vehicle = vehicle;
    },
    setShowModal(state, showModal) {
        state.showModal = showModal;
    },
    setPaymentSearch(state, paymentSearch) {
        state.paymentSearch = paymentSearch;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./resources/assets/js/new-vue/store/modules/representative-example.js